<template>
  <modal
    name="modal-category"
    height="auto"
    width="30%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">
    
    <div class="row7">
      <header class="modalHeader flex flexAlignS madalcustomH">
        <p>카테고리 {{modalModify}}({{modalType}})</p>
        <button @click="onClickCancel"></button>
      </header>
    </div>

    <div class="categoryManagemtnCon">
      <div class="inner">
        <!-- PRODUCT -->
        <div v-if="type === 'PRODUCT'">
          <div class="categoryEnrollBox">
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>실내외 선택</h5>
              </div>
              <select v-model="selectedInOut">
                <option v-for="(inOut, index) in inOutList" :key="index" :value="inOut">{{inOut}}</option>
              </select>
            </div>
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>장소 선택</h5>
              </div>
              <select v-model="selectedPlace">
                <option v-for="(place, index) in placeList" :key="index" :value="place.IDX">{{place.NAME}}</option>
              </select>
            </div>
          </div>
          <div class="categoryEnrollBox">
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>{{modalType}} 산업 분류(1차)</h5>
              </div>
              <select v-model="selectedIndustry">
                <option v-for="(industry, index) in industryList" :key="index" :value="industry.IDX">{{industry.NAME}}</option>
              </select>
            </div>
            <div class="categoryEnrollInput">
              <!-- 간격맞추기 -->
            </div>
          </div>
        </div>
        <!-- SERVICE -->
        <div v-if="type === 'SERVICE'">
          <div class="categoryEnrollBox">
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>대상자구분</h5>
              </div>
              <select v-model="selectedTarget">
                <option v-for="(target, index) in targetList" :key="index" :value="target.IDX">{{target.NAME}}</option>
              </select>
            </div>
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>서비스 선택</h5>
              </div>
              <select v-model="selectedService">
                <option v-for="(service, index) in serviceList" :key="index" :value="service">{{service}}</option>
              </select>
            </div>
          </div>
          <div class="categoryEnrollBox">
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>생활 선택</h5>
              </div>
              <select v-model="selectedLife">
                <option v-for="(life, index) in lifeList" :key="index" :value="life.IDX">{{life.NAME}}</option>
              </select>
            </div>
            <div class="categoryEnrollInput">
              <div class="title">
                <h5>{{modalType}} 산업 분류(1차)</h5>
              </div>
              <select v-model="selectedIndustry">
                <option v-for="(industry, index) in industryList" :key="index" :value="industry.IDX">{{industry.NAME}}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="categoryEnrollInput">
          <div class="title">
            <h5>{{modalType}} 산업 분류(2차)</h5>
          </div>
          <input v-model="category"/>
        </div>
      </div>
    </div>
    
    <div class="modalFooterBtn btnBox">
      <button class="redBtn" @click="onClickSave">{{modalModify}}</button>
      <button class="redborderBtn" @click="onClickCancel">취소</button>
    </div>
  </modal>
</template>

<script>
import {mapActions} from 'vuex'
import * as validationUtil from '@/utils/validationUtil'

export default {
  name: 'ModalCategory',
  props:[
    'type',
    'isModify',
    'mod_category',
    'mod_categoryIdx',
    'mod_industryIdx',
    'mod_placeIdx',
    'mod_targetIdx',
    'mod_lifeIdx'
  ],
  data(){
    return{
      modalResult: false,

      inOutList: [],
      selectedInOut: '',

      placeListAll: [],
      placeList: [],
      selectedPlace: '',

      targetList: [],
      selectedTarget: '',

      serviceList:[],
      selectedService: '',

      lifeListAll:[],
      lifeList:[],
      selectedLife: '',

      industryList: [],
      selectedIndustry: '',

      category: '',
    }
  },
  watch: {
    selectedInOut: function (val) {
      // 장소 초기화
      this.placeList = []

      for(var i = 0; i < this.placeListAll.length; i++){
        if(this.placeListAll[i].IN_OUT === val){
          this.placeList.push(this.placeListAll[i])
        }
      }

      if(this.placeList.length > 0){
        if(this.isModify){
          this.selectedPlace = this.mod_placeIdx
        }
        else{
          this.selectedPlace = this.placeList[0].IDX
        }
      }
    },
    selectedService: function(val){
      // 생활 초기화 
      this.lifeList = []

      for(var i = 0; i < this.lifeListAll.length; i++){
        if(this.lifeListAll[i].SERVICE === val){
          this.lifeList.push(this.lifeListAll[i])
        }
      }

      if(this.lifeList.length > 0){
        if(this.isModify){
          this.selectedLife = this.mod_lifeIdx
        }
        else{
          this.selectedLife = this.lifeList[0].IDX
        }
      }
    }
  },
  computed:{
    modalType(){
      if(this.type === 'PRODUCT'){
        return '제품'
      }

      if(this.type === 'SERVICE'){
        return '서비스'
      }

      return ''
    },
    modalModify(){
      let str = ''
      if(this.isModify){
        str = '수정'
      }
      else{
        str = '등록'
      }

      return str
    }
  },
  mounted(){
    this.show()
  },
  methods:{
     ...mapActions('category', [
      'requestPlaceList',
      'requestTargetList',
      'requestLifeList',
      'requestIndustryList',
      'saveProductCategory',
      'saveServiceCategory'
    ]),
    show(){
      this.$modal.show('modal-category')
    },
    hide(){
      this.$modal.hide('modal-category')
    },
    beforeOpen(){
      this.init()
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    init(){
      if(this.type === 'PRODUCT'){
        this.requestPlaceList()
        .then((response) => {
          // 실내외 리스트 초기화
          this.inOutList = response.data.inOutList
          this.placeListAll = response.data.list

          if(this.isModify){
            for(var i = 0; i < this.placeListAll.length; i++){
              if(this.placeListAll[i].IDX === this.mod_placeIdx){
                this.selectedInOut = this.placeListAll[i].IN_OUT
                break
              }
            }
          }
          else{
            this.selectedInOut = response.data.inOutList[0]
          }
        })
        .catch(() => {
          this.$alert('알림', '데이터를 가져올 수 없습니다.', '확인', {
            'closed': () => {
              this.hide()  
            }
          })
        })
      }
      else if(this.type === 'SERVICE'){
        this.requestTargetList()
        .then((response) => {
          // 대상자 리스트 초기화
          this.targetList = response.data

          if(this.isModify){
            this.selectedTarget =this.mod_targetIdx
          }
          else{
            this.selectedTarget = response.data[0].IDX
          }
        })
        .catch(() => {
          this.$alert('알림', '데이터를 가져올 수 없습니다.', '확인', {
            'closed': () => {
              this.hide()  
            }
          })
        })

        this.requestLifeList()
        .then((response) => {
          // 생활 리스트 초기화
          this.serviceList = response.data.serviceList
          this.lifeListAll = response.data.list

          if(this.isModify){
            for(var i = 0; i < this.lifeListAll.length; i++){
              if(this.lifeListAll[i].IDX === this.mod_lifeIdx){
                this.selectedService = this.lifeListAll[i].SERVICE
                break
              }
            }
          }
          else{
            this.selectedService = response.data.serviceList[0]
          }
        })
        .catch(() => {
          this.$alert('알림', '데이터를 가져올 수 없습니다.', '확인', {
            'closed': () => {
              this.hide()  
            }
          })
        })
      }

      this.requestIndustryList(this.type)
      .then((response) => {
        // 산업분류 초기화
        this.industryList = response.data

        if(this.isModify){
          this.selectedIndustry = this.mod_industryIdx
        }
        else{
          this.selectedIndustry = response.data[0].IDX
        }
      })
      .catch(() => {
        this.$alert('알림', '데이터를 가져올 수 없습니다.', '확인', {
          'closed': () => {
            this.hide()  
          }
        })
      })

      if(this.isModify){
        this.category = this.mod_category
      }
    },
    onClickSave(){
      if(this.type === 'PRODUCT'){
        if(validationUtil.isEmpty(this.selectedInOut)){
          this.$alert('알림', '실내외를 선택해주세요.')
          return 
        }
        if(validationUtil.isEmpty(this.selectedPlace)){
          this.$alert('알림', '장소를 선택해주세요.')
          return 
        }
        if(validationUtil.isEmpty(this.selectedIndustry)){
          this.$alert('알림', '1차 분류를 선택해주세요.')
          return
        }
        if(validationUtil.isEmpty(this.category)){
          this.$alert('알림', '2차 분류를 입력해주세요.')
          return 
        }

        if(!this.isModify){
          this.mod_categoryIdx = 0
        }
        else{
          if(this.selectedPlace == this.mod_placeIdx &&
          this.selectedIndustry == this.mod_industryIdx &&
          this.category == this.mod_category){
            // 수정된게 없는 경우 
            this.modalResult = true
            this.hide() 
            return
          }
        }

        this.saveProductCategory({
          isModify: this.isModify,
          idx: this.mod_categoryIdx,
          name: this.category,
          industryIdx: this.selectedIndustry,
          placeIdx: this.selectedPlace
        })
        .then((response)=>{
          if(response.status === 200){
            this.$alert('알림', '저장되었습니다.', '확인', {
              'closed': () => {
                this.modalResult = true
                this.hide()  
              }
            })
          }
          else{
            this.$alert('알림', '데이터를 저장할 수 없습니다.')
          }
        })
        .catch(error =>{
          if(error.response.status === 409){
            this.$alert('알림', '이미 존재하는 카테고리 입니다.')  
          }
          else{
            this.$alert('알림', '데이터 통신을 실패했습니다.')
          }
        })
      }
      else if(this.type === 'SERVICE'){
        if(validationUtil.isEmpty(this.selectedTarget)){
          this.$alert('알림', '대상자구분을 선택해주세요.')
          return 
        }
        if(validationUtil.isEmpty(this.selectedService)){
          this.$alert('알림', '서비스를 선택해주세요.')
          return 
        }
        if(validationUtil.isEmpty(this.selectedLife)){
          this.$alert('알림', '생활을 선택해주세요.')
          return 
        }
        if(validationUtil.isEmpty(this.selectedIndustry)){
          this.$alert('알림', '1차 분류를 선택해주세요.')
          return
        }
        if(validationUtil.isEmpty(this.category)){
          this.$alert('알림', '2차 분류를 입력해주세요.')
          return 
        }

        if(!this.isModify){
          this.mod_categoryIdx = 0
        }
        else{
          if(this.selectedTarget == this.mod_targetIdx &&
          this.selectedLife == this.mod_lifeIdx &&
          this.selectedIndustry == this.mod_industryIdx &&
          this.category == this.mod_category){
            // 수정된게 없는 경우 
            this.modalResult = true
            this.hide() 
            return
          }
        }

        this.saveServiceCategory({
          isModify: this.isModify,
          idx: this.mod_categoryIdx,
          name: this.category,
          industryIdx: this.selectedIndustry,
          targetIdx: this.selectedTarget,
          lifeIdx: this.selectedLife
        })
        .then((response)=>{
          if(response.status === 200){
            this.$alert('알림', '저장되었습니다.', '확인', {
              'closed': () => {
                this.modalResult = true
                this.hide()  
              }
            })
          }
          else{
            this.$alert('알림', '데이터를 저장할 수 없습니다.')
          }
        })
        .catch(error =>{
          if(error.response.status === 409){
            this.$alert('알림', '이미 존재하는 카테고리 입니다.')  
          }
          else{
            this.$alert('알림', '데이터 통신을 실패했습니다.')
          }
        })
      }
    },
    onClickCancel(){
      this.hide()
    }
  }
}
</script>